// =============================================================================
// FILE PATH : src/modules/pms/wbs_template/components/TemplateTaskList.js
// MODULE    : PMS → WBS Template Integration
// PURPOSE   : Renders task list with checkbox selection
// =============================================================================

import React from "react";


// -----------------------------------------------------------------------------
// STYLES
// -----------------------------------------------------------------------------
const taskCardStyle = {
  border: "1px solid #e5e7eb",
  borderRadius: "6px",
  padding: "8px 10px",
  marginBottom: "8px",
  display: "flex",
  alignItems: "flex-start",
  gap: "10px",
  transition: "all 0.2s ease",
  background: "#fff"
};

const selectedTaskCardStyle = {
  background: "#eff6ff",
  border: "1px solid #93c5fd"
};

const taskNameStyle = {
  fontWeight: "500",
  fontSize: "14px",
  color: "#111827"
};

const taskMetaStyle = {
  marginTop: "4px",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  flexWrap: "wrap"
};

const badgeStyle = {
  fontSize: "11px",
  padding: "2px 8px",
  borderRadius: "999px",
  background: "#f3f4f6",
  color: "#374151",
  fontWeight: "500"
};


// -----------------------------------------------------------------------------
// COMPONENT
// -----------------------------------------------------------------------------
const TemplateTaskList = ({
  tasks = [],
  selectedTasks = [],
  onToggle,
  searchText = ""
}) => {

  // ---------------------------------------------------------------------------
  // CHECK SELECTED
  // ---------------------------------------------------------------------------
  const isSelected = (task) =>
    selectedTasks.some(
      (t) => t.task_name === task.task_name
    );

  // ---------------------------------------------------------------------------
  // SEARCH HIGHLIGHT
  // ---------------------------------------------------------------------------
  const highlightText = (text = "") => {

    if (!searchText?.trim()) {
      return text;
    }

    const escapedSearch = searchText.replace(
      /[.*+?^${}()|[\]\\]/g,
      "\\$&"
    );

    const regex = new RegExp(`(${escapedSearch})`, "gi");

    const parts = text.split(regex);

    return parts.map((part, index) => {

      const isMatch =
        part.toLowerCase() === searchText.toLowerCase();

      return isMatch ? (
        <span
          key={index}
          style={{
            background: "#fde68a",
            padding: "0 2px",
            borderRadius: "2px"
          }}
        >
          {part}
        </span>
      ) : (
        <React.Fragment key={index}>
          {part}
        </React.Fragment>
      );
    });
  };

  // ---------------------------------------------------------------------------
  // EMPTY
  // ---------------------------------------------------------------------------
  if (!tasks.length) {

    return (
      <div style={{
        padding: "8px",
        color: "#666",
        fontSize: "13px"
      }}>
        No tasks found
      </div>
    );
  }

  // ---------------------------------------------------------------------------
  // RENDER
  // ---------------------------------------------------------------------------
  return (
    <div style={{ marginTop: "6px" }}>

      {tasks.map((task) => {

        const selected = isSelected(task);

        return (
          <div
            key={task.id || task.task_name}
            style={{
              ...taskCardStyle,
              ...(selected
                ? selectedTaskCardStyle
                : {})
            }}
          >

            {/* CHECKBOX */}
            <div style={{
              paddingTop: "2px"
            }}>
              <input
                type="checkbox"
                checked={selected}
                onChange={() => onToggle(task)}
              />
            </div>

            {/* CONTENT */}
            <div style={{
              flex: 1,
              cursor: "pointer"
            }}
            onClick={() => onToggle(task)}
            >

              {/* TASK NAME */}
              <div style={taskNameStyle}>
                {highlightText(task.task_name)}
              </div>

              {/* META */}
              <div style={taskMetaStyle}>

                {/* CATEGORY */}
                {task.task_category && (
                  <span style={badgeStyle}>
                    {highlightText(task.task_category)}
                  </span>
                )}

                {/* DURATION */}
                {task.default_duration && (
                  <span style={{
                    fontSize: "11px",
                    color: "#6b7280"
                  }}>
                    ⏱ {task.default_duration} Days
                  </span>
                )}

              </div>

              {/* DESCRIPTION */}
              {task.description && (
                <div style={{
                  marginTop: "5px",
                  fontSize: "12px",
                  color: "#6b7280",
                  lineHeight: "1.4"
                }}>
                  {highlightText(task.description)}
                </div>
              )}

            </div>

          </div>
        );
      })}

    </div>
  );
};

export default TemplateTaskList;